import { useContext } from "react";
import { MODES } from "../../commons/constants/user";
import { AppContext } from "../../contexts/AppContext";
import useControlTabs from "../../hooks/useControlTabs";
import StoreOfficial from "./StoreOfficial";
import StoreTabs from "./StoreTabs";
import styles from "./store-management.module.scss";

export enum STORETAB {
  OFFICIAL = "1",
  PENDING = "2",
  REJECTED = "3",
}
const StoreManagement = () => {
  const { user } = useContext(AppContext);
  const { activeTab, onChange } = useControlTabs(STORETAB.OFFICIAL.toString());
  const isAdmin = user?.merchant_role?.id === MODES.ADMIN;

  if (isAdmin) {
    return (
      <>
        <StoreTabs activeTab={activeTab} onChange={onChange} />
      </>
    );
  } else {
    return (
      <div className={styles.wrapper}>
        <div className={styles.titleWrapper}>
          <div className={styles.title}>Store List</div>
        </div>
        <StoreOfficial activeTab={activeTab} />
      </div>
    );
  }
};

export default StoreManagement;
